module.exports = "/_next/static/images/PersonalizationEngine@2x-a25b5d6fa2c0c3a743a4ac0a7d407e3a.png";